const menus = [
    {
        id: 1,
        name: 'Home',
        links: '/'
    },
    {
        id: 2,
        name: 'HistoryStudio',
        links: '/my-history-studio'
    },
    {
        id: 3,
        name: 'Photo',
        links: '/photo'
    },
    {
        id: 4,
        name: 'Video',
        links: '/video'
    },
    {
        id: 5,
        name: 'Web',
        links: '/web',
        namesub: [
            {
                id: 1,
                sub: 'webGFX',
                links: '/webgfx'
            },
        ],
    },

]

export default menus;